var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDullness = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 23,
    viewBox: "0 0 51 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 23L-3.8147e-06 23L-3.55243e-06 20C-2.58678e-06 8.9543 8.9543 1.38945e-07 20 1.10459e-06L31 2.06624e-06C42.0457 3.03189e-06 51 8.95431 51 20L51 23Z",
    fill: "url(#paint0_radial_848_5973)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_848_5973",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5 23) rotate(-90) scale(23 25.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#283333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283333",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDullness);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCA1MSAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUxIDIzTC0zLjgxNDdlLTA2IDIzTC0zLjU1MjQzZS0wNiAyMEMtMi41ODY3OGUtMDYgOC45NTQzIDguOTU0MyAxLjM4OTQ1ZS0wNyAyMCAxLjEwNDU5ZS0wNkwzMSAyLjA2NjI0ZS0wNkM0Mi4wNDU3IDMuMDMxODllLTA2IDUxIDguOTU0MzEgNTEgMjBMNTEgMjNaIiBmaWxsPSJ1cmwoI3BhaW50MF9yYWRpYWxfODQ4XzU5NzMpIi8+CjxkZWZzPgo8cmFkaWFsR3JhZGllbnQgaWQ9InBhaW50MF9yYWRpYWxfODQ4XzU5NzMiIGN4PSIwIiBjeT0iMCIgcj0iMSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIGdyYWRpZW50VHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjUuNSAyMykgcm90YXRlKC05MCkgc2NhbGUoMjMgMjUuNSkiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMjgzMzMzIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzI4MzMzMyIgc3RvcC1vcGFjaXR5PSIwIi8+CjwvcmFkaWFsR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";